import Box from "@mui/material/Box";

import { ButtonUI } from "../../../../../Common";

const Footer = ({ disabled, handleSaveDetails, onClose }) => {
  return (
    <Box my={2}>
      <ButtonUI
        disabled={disabled}
        variant="contained"
        color="success"
        onMouseDown={(e) => e.preventDefault()}
        onClick={(e) => handleSaveDetails("manual")}
      >
        Save
      </ButtonUI>
      <ButtonUI
        variant="contained"
        color="secondary"
        style={{ marginLeft: 15 }}
        onMouseDown={(e) => e.preventDefault()}
        onClick={onClose}
      >
        Cancel
      </ButtonUI>
    </Box>
  );
};

export default Footer;
